import { selectFilter } from "../../../../services/FilteringUtils";

export const knowledge_item_ASPS = {
  correctWords: selectFilter(),
  phrases: selectFilter(),
  anyWords: selectFilter(),
  nonWords: selectFilter(),
  documentSearchQuery: selectFilter(),
  extensions: {
    ...selectFilter(),
    nestedId: "id"
  },
  tags: {
    ...selectFilter(),
    nestedId: "name"
  },
  autoTags: {
    ...selectFilter(),
    nestedId: "name"
  },
  classifications: {
    ...selectFilter(),
    nestedId: "id"
  },
  knowledgeTypes: {
    ...selectFilter(),
    nestedId: "id"
  },
  knowledgeSources: {
    ...selectFilter(),
    nestedId: "id"
  }
};
